import axios, { AxiosError } from 'axios'
import { useState } from 'react';
import  config from '../config/config';
import { IEPGroup, IEPGroupType, IEPGroupAwardDetail } from '../interfaces/EPGroup';
import  {IEPSchedule} from '../interfaces/EPSchedule';


export const getEPScedule=()=>{
    const url=config.server.url+`/api/DrSchedule/yr/112年度`

    return axios.get(url).then((res)=>{
        const rest:IEPSchedule[]=res.data;
        console.log(rest);
        return rest;
    })
    .catch((error:AxiosError) => {
        throw error;
    });
}

export const getEPGroup=(yr:string,type:string)=>{
    const url=config.server.url+`/api/DrGroup/yr/${yr}/type/${type}`

    return axios.get(url).then((res)=>{
        const rest:IEPGroup[]=res.data;
        console.log(rest);
        return rest;
    })
    .catch((error:AxiosError) => {
        throw error;
    });
}

export const getEPGroupByYr=(yr:string)=>{
    const url=config.server.url+`/api/DrGroup/yr/${yr}`

    return axios.get(url).then((res)=>{
        const rest:IEPGroup[]=res.data;
        return rest;
    })
    .catch((error:AxiosError) => {
        throw error;
    });
}

// 新增取得特定年度獲獎隊伍詳細資料
export const getEPGroupAwardByYr=(yr:string)=>{
    // 對年度參數進行 URL 編碼，確保中文字符正確傳遞
    const encodedYr = encodeURIComponent(yr);
    const url=config.server.url+`/api/DrGroup/award/yr/${encodedYr}`

    console.log('API 請求 URL:', url);
    console.log('API 基礎 URL:', config.server.url);
    console.log('年度參數 (原始):', yr);
    console.log('年度參數 (編碼後):', encodedYr);
    
    return axios.get(url, {
        timeout: 10000, // 10 秒超時
        headers: {
            'Content-Type': 'application/json',
        }
    }).then((res)=>{
        const rest:IEPGroupAwardDetail[]=res.data;
        console.log('API 回應資料:', rest);
        console.log('API 回應狀態:', res.status);
        return rest;
    })
    .catch((error:AxiosError) => {
        // 詳細的錯誤診斷
        const errorInfo = {
            url: url,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            message: error.message,
            code: error.code,
            config: {
                method: error.config?.method,
                url: error.config?.url,
                baseURL: error.config?.baseURL,
            }
        };
        
        console.error('●▶API 請求失敗:', errorInfo);
        
        // 如果是 Network Error，提供更詳細的診斷
        if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
            console.error('⚠️ Network Error 可能的原因:');
            console.error('1. 後端伺服器未運行');
            console.error('2. CORS 設定問題');
            console.error('3. 網路連線問題');
            console.error('4. HTTPS/HTTP 混合內容問題');
            console.error('請檢查:');
            console.error(`- 後端伺服器是否運行在 ${config.server.url}`);
            console.error('- 瀏覽器 Console 是否有 CORS 錯誤');
            console.error('- 網路連線是否正常');
        }
        
        throw error;
    });
}

// 建立年度參賽隊伍資料,以小組分類
export const getEPGroupType=(grp:IEPGroupType):IEPGroup[][]=>{
    let result:IEPGroup[][]=[[]];
    let temp:IEPGroup[];
    getEPGroupByYr(grp.Year).then((res)=>{
        temp=res;
        grp.GroupType.forEach((item,idx)=>{
            const filter=temp.filter((titem)=>titem.Type===item);
            console.log('filter len:'+filter.length);
            result[idx]=filter;
            console.log('result idx:'+idx)
            console.log(result[idx]);
            console.log('result all:')
            console.log(result);
            //result.push(res.filter((titem)=>titem.Type===item));

        });
        console.log('in process1:')
        console.log(result);
        return result;        
    });
    console.log('in process:'+result);
    return result;
}

        










